<template>
  <!-- 测点定位弹窗 -->
  <div>
    <div v-for="(item, index) in pointDialog" :key="index">
      <div
        v-drag
        class="point_dialog w-325px h-160px left-1/2 top-1/2 z-index-9998 text-white py-4 flex flex-col justify-around cursor-move"
        :style="{ left: `${item.position.left}px`, top: `${item.position.top}px` }"
        v-if="item.visible"
      >
        <span class="point_dialog_close z-9999" @click="$emit('closeItem', item)"></span>
        <el-row
          class="flex"
          v-for="(pointDataHeaderItem, pointDataHeaderIndex) in pointDataHeader"
          :key="pointDataHeaderIndex"
        >
          <el-col :span="8">
            <div class="text-[#c3c3c3] text-right">{{ pointDataHeaderItem[1] }}：</div>
          </el-col>
          <el-col :span="16">
            <el-tooltip
              :content="item.pointItem[pointDataHeaderItem[0]]"
              placement="top"
              :open-delay="500"
              :disabled="!item.pointItem[pointDataHeaderItem[0]]"
            >
              <div class="flex-1 truncate">{{ item.pointItem[pointDataHeaderItem[0]] }}</div>
            </el-tooltip>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    pointDialog: {
      type: Array,
      default: () => {
        return [
          {
            pointItem: [],
            visible: false,
          },
        ]
      },
    },
    pointDataHeader: {
      type: Map,
    },
  },
  data() {
    return {}
  },
  methods: {},
}
</script>

<style lang="scss" scoped>
.point_dialog {
  position: fixed;
  background-color: transparent;
  background-image: url('./images/矩形备份14@1x.png');
  background-size: 100% 100%;

  .point_dialog_close {
    position: absolute;
    top: 10px;
    right: 10px;
    width: 20px;
    height: 20px;
    background-image: url('./images/bg_pop_close@1x.png');
    background-size: 100% 100%;
    cursor: pointer;
  }
}
</style>
